import { makeValuesPredicate } from '@sgme/fp';

export interface TabsForWorkspace {
  static: 'quote' | 'reprice';
  dynamic: 'quote' | 'reprice';
  newBatch: 'quote' | 'reprice' | 'import';
  postTrade: 'addOn' | 'productModification' | 'tradeAllocation';
  ordersBasket: undefined;
  addonManagement: undefined;
  secondaryMarketQuotes: 'realtimeQuote' | 'closePriceOrder' | 'live' | 'limitOrder' | 'dlpProducts';
  secondaryMarketPostEvents: 'closePriceOrder' | 'live' | 'limitOrder';
  essential: 'quote' | 'reprice';
  smartQuote: 'quote';
}

export type WorkspaceType = keyof TabsForWorkspace;
export type SecondaryWorkspaceType = Extract<WorkspaceType, 'secondaryMarketQuotes' | 'secondaryMarketPostEvents'>;

export const QUOTE_WORKSPACES = [
  'static',
  'dynamic',
  'newBatch',
  'postTrade',
  'secondaryMarketQuotes',
  'essential',
  'smartQuote',
] as const;
export type QuoteWorkspaceType = (typeof QUOTE_WORKSPACES)[number];

export type TabType = TabsForWorkspace[WorkspaceType];

export type SecondaryMarketPostEventTabType = TabsForWorkspace['secondaryMarketPostEvents'];

export type SecondaryMarketQuotesTabType = TabsForWorkspace['secondaryMarketQuotes'];

export function isSecondaryMarketQuotesTabType(
  tabType: string | null | undefined,
): tabType is SecondaryMarketQuotesTabType {
  switch (tabType) {
    case 'realtimeQuote':
    case 'closePriceOrder':
    case 'live':
    case 'dlpProducts':
      return true;
    default:
      return false;
  }
}
export const isQuoteWorkspaceType = makeValuesPredicate(QUOTE_WORKSPACES);
export function canWorkspaceBeEmpty(workspace: WorkspaceType) {
  return workspace === 'postTrade' || workspace === 'secondaryMarketQuotes';
}
